import Vue from 'vue'
import Vuex from 'vuex'
import Init from './modules/init'
import Note from './modules/note'
import Client from './modules/client'
import Invoice from './modules/invoice'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        init: Init,
        note: Note,
        client: Client,
        invoice: Invoice
    },
})
